import { Link } from "react-router-dom";

export default function Investments() {
    return (
        <div className="p-1 md:p-6">
            <h2 className="text-2xl md:text-4xl mb-3 font-bold">KHAN PLUS</h2>
            <p className="text-base md:text-xl">
                This is a live simulation of the KHAN PLUS DeFi investment pool.
                Please create an account to start using your demo account and explore the live performance.
                For security reasons, we recommend that you do not use the same credentials as in your banking app. <br />
                For more information about KHAN PLUS, please click
                <Link
                    to={`https://belobaba.io/investments/khan-plus/`}
                    className="text-blue-500 text-base md:text-lg ml-1 underline inline-block"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Here
                </Link>
            </p>
            <div className="mt-4 bg-white rounded-2xl p-4">
                <iframe
                    src="https://khanplusdemo.belobaba.io/"
                    className="w-full max-w-full h-[100vh] md:h-[800px] rounded-2xl bg-white"
                    title="KHAN PLUS Demo"
                    style={{ backgroundColor: 'white' }}
                />
            </div>
        </div>
    );
}
